import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Home, Compass } from "lucide-react";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Page Not Found — LumberLoop USA";
  }, []);

  return (
    <div data-testid="not-found-page" className="min-h-[70vh] bg-white flex items-center relative overflow-hidden">
      <div className="absolute inset-0 grid-backdrop opacity-40 -z-0"/>

      <div className="relative max-w-3xl mx-auto px-6 lg:px-10 py-24 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-slate-200 shadow-sm">
          <span className="w-1.5 h-1.5 bg-[#C62828] rounded-full"/>
          <span className="font-mono-ll text-[10px] tracking-[0.24em] uppercase text-[#17324D] font-semibold">404 · Not Found</span>
        </div>

        <h1 className="font-display text-5xl md:text-7xl mt-6 text-[#17324D] leading-none">
          Off the <span className="text-[#C62828]">map.</span>
        </h1>

        <p className="mt-6 text-lg text-slate-600 max-w-lg mx-auto">
          The page <code className="font-mono-ll text-[13px] bg-slate-100 px-1.5 py-0.5 rounded">{location.pathname}</code> doesn&apos;t exist — or it moved. Let&apos;s get you back on track.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-primary" data-testid="notfound-cta-home">
            <Home size={16}/> Return Home
          </Link>
          <Link to="/platform" className="btn-secondary" data-testid="notfound-cta-platform">
            <Compass size={16}/> Explore Platform
          </Link>
          <button type="button" onClick={() => window.history.back()} className="btn-ghost" data-testid="notfound-cta-back">
            <ArrowLeft size={16}/> Go Back
          </button>
        </div>

        <div className="mt-10 text-sm text-slate-500">
          Looking for something specific?{" "}
          <Link to="/contact" className="text-[#17324D] font-semibold hover:text-[#C62828]">Contact us →</Link>
        </div>
      </div>
    </div>
  );
}
